module.exports = __webpack_public_path__ + "static/media/hero-collage.49b2cbc4.png";